import { TeamExternalIntegration } from 'types/api/services/golden-signal'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'

export const prometheusStatusCheckIntegration: TeamExternalIntegration = {
  name: 'Prometheus',
  type: IntegrationType.Custom,
  authUrl: '',
  isPrivateNetworkIntegration: false,
  headers: [],
  url: '',
  sortIndex: 6
}
